import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import SoccerFormation from './soccer/SoccerFormation';

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/soccer" element={<SoccerFormation />} />
      <Route path="/soccer/:date" element={<SoccerFormation />} />
      <Route path="*" element={<h1>There is nothing here.</h1>} />
    </Routes>
  </BrowserRouter>
);

export default App;
